import { useState } from 'react';
import { useSelector } from 'react-redux';
import { lavaInvoiceUrl } from '@pisaka/core/endpointUrls/endpointUrls';
import { axiosInstance } from '../../helpers/axiosInstance';
import { AppStateTypes } from '../../store/appStateTypes';
import { socket } from '../../helpers/socket';

type LavaInvoiceParams =
  | { type: 'font_purchase'; fontId: string; currency?: 'USD' | 'EUR'; returnUrl?: string }
  | { type: 'premium_purchase'; planId: string; currency?: 'USD' | 'EUR'; returnUrl?: string }
  | { type: 'token_purchase'; planId: string; currency?: 'USD' | 'EUR'; returnUrl?: string };

type LavaInvoiceResult = {
  paymentUrl: string;
  contractId: string;
};

export const useLavaInvoice = () => {
  const { token } = useSelector((state: AppStateTypes) => state.auth) || {};
  const [isLoading, setIsLoading] = useState(false);

  const createInvoice = async (params: LavaInvoiceParams): Promise<LavaInvoiceResult> => {
    setIsLoading(true);
    try {
      const { data } = await axiosInstance(token).post<LavaInvoiceResult>(lavaInvoiceUrl, params);
      return data;
    } finally {
      setIsLoading(false);
    }
  };

  const openPayment = async (
    params: LavaInvoiceParams,
    onSuccess: (payload: Record<string, unknown>) => void,
  ) => {
    const { paymentUrl, contractId } = await createInvoice(params);

    socket.on(`payment:${contractId}`, (payload: Record<string, unknown>) => {
      socket.off(`payment:${contractId}`);
      onSuccess(payload);
    });

    window.location.href = paymentUrl;

    return contractId;
  };

  return { createInvoice, openPayment, isLoading };
};
